export default __webpack_public_path__ + "static/media/14_D.73c0b8ef.svg";